module.exports = __webpack_public_path__ + "img/sw04.3b9187af.jpg";